import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import { setSessionStorage, isClient } from '@tcp/core/src/utils';
import {
  NewSearchedTextTitleRow,
  SearchedLabel,
  NewProductCountTextSearch,
  RelatedSearchWrapper,
  SearchedText,
  RelatedText,
  RelatedSearches,
  SlpPersistRelatedSearch,
  EnteredText,
  SlpInsteadSearch,
  NullSearchCount,
} from '../SearchKeywords.style';
import { redirectToSuggestedUrl, enteredSearchText } from '../container/SearchDetail.util';
import { SLP_SUB_LABELS, slpSubLabels } from '../../../../../utils/labels/browse/SLP.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import { capitalizeFirstWordOfSentence } from '../../../../../utils/utils.web';

export const renderRelatedSearches = (
  searchResultKeywords,
  trackClickAnalyticsBopisFilter,
  searchedText,
  searchTopPromos
) => {
  const searchResultKeywordSuggestions = searchResultKeywords;
  if (searchResultKeywordSuggestions?.length > 4) {
    searchResultKeywordSuggestions.length = 4;
  }
  let duplicateSuggestionToDelete;
  searchResultKeywordSuggestions?.forEach((item, index) => {
    if (item?.text?.toLowerCase() === searchedText?.toLowerCase()) {
      duplicateSuggestionToDelete = index;
    }
  });
  if (duplicateSuggestionToDelete !== undefined) {
    searchResultKeywordSuggestions?.splice(duplicateSuggestionToDelete, 1);
  }
  return (
    <RelatedSearchWrapper className="related-search-wrapper" searchTopPromos={searchTopPromos}>
      {searchResultKeywordSuggestions?.length ? (
        <RelatedText className="related-text">Related{': '}</RelatedText>
      ) : null}
      <RelatedSearches className="related-searches">
        {searchResultKeywordSuggestions?.map((item, index) => {
          return (
            <SlpPersistRelatedSearch
              underline
              className="slp-persist-related-search"
              anchorVariation="primary"
              tabIndex="0"
              key={index}
              to={(isClient() && item && `/search/${item.text}`) || ''}
              onClick={(e) => {
                e.preventDefault();
                setSessionStorage({ key: 'relatedSearch', value: `${item?.text}` });
                redirectToSuggestedUrl(`${item?.text}`);
              }}
            >
              {item?.text}
            </SlpPersistRelatedSearch>
          );
        })}
      </RelatedSearches>
    </RelatedSearchWrapper>
  );
};

const renderAcrossBrandLabels = (searchText) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);
  return (
    <div>
      <BodyCopy component="span" fontWeight={['normal']} fontFamily="secondary" fontSize="fs18">
        {`${renderLabel(slpLabels?.lbl_noresults_found_for, 'lbl_noresults_found_for')} `}
        <BodyCopy
          component="span"
          fontWeight={['bold']}
          fontFamily="secondary"
          fontSize="fs18"
        >{`"${searchText}"`}</BodyCopy>
      </BodyCopy>
      <BodyCopy component="p" fontWeight={['normal']} fontFamily="secondary" fontSize="fs24">
        {renderLabel(
          slpLabels?.lbl_showing_results_from_our_other_brands,
          'lbl_showing_results_from_our_other_brands'
        )}
      </BodyCopy>
    </div>
  );
};

// eslint-disable-next-line complexity
const renderDidYouMean = (
  searchedText,
  didYouMeanNullSearch,
  acrossBrandApiCalled,
  isFeatureBrandView,
  featureBrand,
  totalProductsCount
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);
  const enteredText = [];
  enteredText.push({ suggestion: searchedText });
  const enteredValue = enteredSearchText();
  let searchText = searchedText;
  if (searchedText === '*' && isShopThisStoreModeOn()) {
    return null;
  }
  if (isFeatureBrandView && featureBrand) {
    searchText = capitalizeFirstWordOfSentence(featureBrand);
  }
  return (
    <div className="didyoumean-container">
      {!isFeatureBrandView && (
        <SearchedText
          fontSize={`${acrossBrandApiCalled ? 'fs14' : 'fs24'}`}
          className="searched-text"
          fontFamily="secondary"
        >
          {searchedText !== enteredSearchText()
            ? `${renderLabel(slpLabels.lbl_showing_x_items, 'lbl_showing_x_items')} results for `
            : `${renderLabel(slpLabels?.lbl_searched_for, 'lbl_searched_for')}`}
          <BodyCopy
            component="span"
            fontWeight={['bold']}
            fontFamily="secondary"
            className="searched-keyword"
          >{`"${searchText}"`}</BodyCopy>
        </SearchedText>
      )}
      {isFeatureBrandView && (
        <SearchedText
          fontSize={`${acrossBrandApiCalled ? 'fs14' : 'fs24'}`}
          className="searched-text"
          fontFamily="secondary"
        >
          {renderLabel(slpLabels.lbl_feature_brand_results_for, 'lbl_results_for')}
          <BodyCopy
            component="span"
            fontWeight={['bold']}
            fontFamily="secondary"
            className="searched-keyword"
          >
            {` "${searchText}"`}
            {totalProductsCount > 0 && totalProductsCount < 50 && ` (${totalProductsCount} items)`}
            {totalProductsCount > 50 && ` (50+ items)`}
          </BodyCopy>
        </SearchedText>
      )}
      {!isFeatureBrandView && searchedText !== enteredSearchText() ? (
        <EnteredText
          fontSize="fs14"
          fontFamily="secondary"
          fontWeight="semibold"
          className="entered-text"
        >
          {`${renderLabel(slpLabels.lbl_search_instead, 'lbl_search_instead')} "`}
          <BodyCopy
            component="span"
            fontWeight={['bold']}
            fontFamily="secondary"
            className="entered-keyword"
          >
            {isShopThisStoreModeOn ? (
              <SlpInsteadSearch
                underline
                className="slp-instead-search"
                anchorVariation="primary"
                tabIndex="0"
                to={
                  (isClient() &&
                    enteredSearchText() &&
                    `/search/shop-this-store/${enteredSearchText()}`) ||
                  ''
                }
                onClick={(e) => {
                  e.preventDefault();
                  didYouMeanNullSearch({ enteredText, enteredValue, searchedText });
                }}
              >
                {`${enteredSearchText()}`}
              </SlpInsteadSearch>
            ) : (
              <SlpInsteadSearch
                underline
                className="slp-instead-search"
                anchorVariation="primary"
                tabIndex="0"
                to={(isClient() && enteredSearchText() && `/search/${enteredSearchText()}`) || ''}
                onClick={(e) => {
                  e.preventDefault();
                  didYouMeanNullSearch({ enteredText, enteredValue, searchedText });
                }}
              >
                {`${enteredSearchText()}`}
              </SlpInsteadSearch>
            )}
            {`"`}
          </BodyCopy>
        </EnteredText>
      ) : (
        ''
      )}
    </div>
  );
};

const processSearchText = (searchTerm) => {
  return decodeURI(searchTerm?.split('?')?.[0]?.split('&')?.[0]);
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const SearchKeywords = (props) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);
  const colSize = { small: 6, medium: 8, large: 12 };
  const {
    searchedText,
    isABTestForStickyFilter,
    searchResultKeywordSuggestions,
    slpPersistSearchTerm,
    isSlpPersistEnabled,
    isLoadingMore,
    isDidYouMeanEnabled,
    isHeaderSticky,
    didYouMeanNullSearch,
    totalProductsCount,
    className,
    trackClickAnalyticsBopisFilter,
    acrossBrandApiCalled,
    searchTopPromos,
    isGlobalHeaderRedesignEnabled,
    isHeaderScrollViewDisabled,
    isFeatureBrandView,
    featureBrand,
  } = props;

  const getSearchString = (text) => {
    return !isLoadingMore && totalProductsCount > 0 ? text : '';
  };

  const isSlpPersistEnabledAb = isSlpPersistEnabled === undefined || isSlpPersistEnabled;
  const searchTermMatch =
    processSearchText(slpPersistSearchTerm) === processSearchText(searchedText);
  const stickySearchKeyWord = 'sticky-search-keyword';
  const searchText = getSearchString(`${searchedText.split('?')[0]}`);
  const [slpRelatedSearches, setSlpRelatedSearches] = useState(searchResultKeywordSuggestions);

  useEffect(() => {
    if (isSlpPersistEnabledAb && searchTermMatch) {
      setSlpRelatedSearches(searchResultKeywordSuggestions);
    }
    return () => setSlpRelatedSearches(undefined); // clearing the records so that, they will not display for another search
  }, [searchTermMatch]);

  const renderLoadedProductCount = () => {
    const { lbl_item: ItemLabel, lbl_items: ItemsLabel } = slpLabels || {};

    return (
      <NewProductCountTextSearch
        className="new-product-count-text-search"
        component="span"
        fontSize="fs12"
        fontFamily="secondary"
      >
        {`(${totalProductsCount} ${totalProductsCount > 1 ? ItemsLabel : ItemLabel})`}
      </NewProductCountTextSearch>
    );
  };

  const renderNewSearchTitle = () => {
    return isABTestForStickyFilter ? (
      <BodyCopy component="span" fontFamily="secondary" fontSize="fs18" fontWeight="extrabold">
        {`${getSearchString(
          renderLabel(slpLabels.lbl_results_for, 'lbl_results_for')
        )} ${getSearchString(`"${searchedText.split('?')[0]}"`)}`}
        {renderLoadedProductCount()}
      </BodyCopy>
    ) : (
      <BodyCopy
        className={`${className} searched-text-wrapper`}
        component="div"
        fontFamily="secondary"
        fontSize="fs14"
        fontWeight="regular"
      >
        {getSearchString(renderLabel(slpLabels.lbl_searched_for, 'lbl_searched_for'))}
        <SearchedLabel
          component="span"
          fontFamily="secondary"
          className="searched-label"
          fontSize={['fs16', 'fs16', 'fs14']}
          fontWeight="extrabold"
          isSlpPersistEnabled={isSlpPersistEnabled}
        >
          {getSearchString(`"${searchedText.split('?')[0]}"`)}
        </SearchedLabel>
      </BodyCopy>
    );
  };

  return (
    <>
      <NewSearchedTextTitleRow
        className={
          isABTestForStickyFilter
            ? `new-searched-text-title ${stickySearchKeyWord}`
            : stickySearchKeyWord
        }
        isABTestForStickyFilter={isABTestForStickyFilter}
        isHeaderSticky={isHeaderSticky}
        acrossBrandApiCalled={acrossBrandApiCalled}
        isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
        isHeaderScrollViewDisabled={isHeaderScrollViewDisabled}
      >
        {!acrossBrandApiCalled && (
          <Col colSize={colSize}>
            {searchedText && isDidYouMeanEnabled && !isLoadingMore
              ? renderDidYouMean(
                  searchText,
                  didYouMeanNullSearch,
                  acrossBrandApiCalled,
                  isFeatureBrandView,
                  featureBrand,
                  totalProductsCount
                )
              : renderNewSearchTitle()}
          </Col>
        )}
        {acrossBrandApiCalled && searchText && renderAcrossBrandLabels(searchText)}
      </NewSearchedTextTitleRow>
      {isSlpPersistEnabledAb &&
        !isLoadingMore &&
        !isShopThisStoreModeOn() &&
        renderRelatedSearches(
          searchTermMatch ? searchResultKeywordSuggestions : slpRelatedSearches,
          trackClickAnalyticsBopisFilter,
          searchedText,
          searchTopPromos
        )}
      <NullSearchCount>
        {acrossBrandApiCalled && !isLoadingMore && (
          <BodyCopy>
            <BodyCopy component="span" fontWeight="semibold">
              {totalProductsCount}
            </BodyCopy>
            {` ${
              totalProductsCount > 1
                ? renderLabel(slpLabels?.lbl_items, 'lbl_items')
                : renderLabel(slpLabels?.lbl_item, 'lbl_item')
            }`}
          </BodyCopy>
        )}
      </NullSearchCount>
    </>
  );
};

SearchKeywords.propTypes = {
  totalProductsCount: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  searchedText: PropTypes.string.isRequired,
  slpLabels: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])).isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
  isHeaderSticky: PropTypes.bool.isRequired,
  searchResultKeywordSuggestions: PropTypes.string.isRequired,
  slpPersistSearchTerm: PropTypes.string.isRequired,
  isSlpPersistEnabled: PropTypes.bool.isRequired,
  isDidYouMeanEnabled: PropTypes.bool.isRequired,
  didYouMeanNullSearch: PropTypes.bool.isRequired,
  isABTestForStickyFilter: PropTypes.bool.isRequired,
  trackClickAnalyticsBopisFilter: PropTypes.func.isRequired,
};

export default React.memo(SearchKeywords);
